module.exports = __webpack_public_path__ + "static/media/fleetvehiclesIcon.865f8c94.svg";